import {
  CHANGE_GLOBAL_ROLE,
  CHANGE_GLOBAL_ROLE_SUCCESS,
  CHANGE_GLOBAL_ROLE_START,
  UPDATE_GLOBAL_ROLE,
  UPDATE_PROJECT_ROLE,
  UPDATE_DATA_MANAGER_ROLE,
  UPDATE_CLIENT_ROLE,
} from './constants'

const changeGlobalRole = (attributes) => ({ type: CHANGE_GLOBAL_ROLE, attributes })
const changeGlobalRoleStart = () => ({ type: CHANGE_GLOBAL_ROLE_START })
const changeGlobalRoleSuccess = () => ({ type: CHANGE_GLOBAL_ROLE_SUCCESS })
const updateGlobalRole = (role) => ({ type: UPDATE_GLOBAL_ROLE, role })
const updateProjectRole = (hasRole) => ({ type: UPDATE_PROJECT_ROLE, hasRole })
const updateDataManagerRole = (hasRole) => ({ type: UPDATE_DATA_MANAGER_ROLE, hasRole })
const updateClientRole = (isClient) => ({ type: UPDATE_CLIENT_ROLE, isClient })

export {
  changeGlobalRole,
  changeGlobalRoleStart,
  changeGlobalRoleSuccess,
  updateGlobalRole,
  updateProjectRole,
  updateDataManagerRole,
  updateClientRole,
}
